module.exports = __webpack_public_path__ + "img/sale-03.c93ab14e.svg";